<template>
  <v-app>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <v-container fluid>
              <v-card-title>
                <v-btn
                  :to="{ name: 'adminDiscounts.create' }"
                  class="btn-add-with-text"
                  v-status="'notification_create'"
                >
                  <v-icon>mdi-plus</v-icon>
                  افزودن
                </v-btn>
                <!--                  <v-spacer/>-->
                <!--                  {{ $t($route.meta.title) }}-->
                <!--                  <v-spacer/>-->
                <!--                  <v-btn :loading="loading" @click="reload"-->
                <!--                         class="btn-update">-->
                <!--                    <v-icon>mdi-refresh</v-icon>-->
                <!--                    به روزرسانی-->
                <!--                  </v-btn>-->
              </v-card-title>
              <v-divider />

              <div class="row">
                <div class="col-md-12 p-5">
                  <data-table
                    orderDir="desc"
                    :data="data"
                    :columns="columns"
                    class="p-2"
                    :debounce-delay="5000"
                    :translate="translate"
                    :per-page="[10, 25, 50, 100, 200, 400]"
                    @on-table-props-changed="reloadTable"
                  >
                  </data-table>
                </div>
              </div>

              <!--              </v-card>-->
            </v-container>
          </div>
        </div>
      </div>
    </div>
    <v-dialog
      transition="dialog-bottom-transition"
      max-width="600"
      v-model="dialog"
    >
      <template v-slot:default="dialog">
        <v-card>
          <v-toolbar color="primary" dark>
            <div class="text-h3 text-center">{{ item.title }}</div>
          </v-toolbar>
          <v-card-text>
            <div class="text-h5 pt-5" v-html="item.text"></div>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn text color="pink" dark @click="dialog.value = false"
              >بستن
            </v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
  </v-app>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Button from "@/view/pages/Button";
import userLinkBtn from "@/view/pages/admin/adminNotifications/userLinkBtn";
import index from "../../../../core/plugins/TitleRibbon/plugins/vueTable/index.vue";
export default {
  data() {
    return {
      loading: false,
      data: {},
      dialog: false,
      item: null,
      url: "admin/discount",
      columns: [
        {
          name: "id",
          label: "شناسه",
          orderable: true,
        },
        {
          label: "عنوان",
          name: "caption",
          orderable: true,
          // transform: (value) => {
          //   return value.data.data.title;
          // }
        },

        {
          label: "درصد تخفیف",
          name: "discount",
          orderable: true,
          transform: (value) => {
            return value.data.discount + "%";
          },
        },

        {
          label: "تعداد کاربران",
          name: "used_count",
          orderable: true,
        },

        {
          label: "پنل",
          name: "packs",
          transform: (value) => {
            return value.data.packs !== null
              ? value.data.packs[0].title
              : "ندارد";
          },
        },

        {
          label: "دفعات قابل استفاده",
          name: "usable",
        },
        {
          label: "امتیاز",
          name: "point",
        },

        {
          name: "price_max",
          label: "سقف(﷼)",
          transform: (value) => {
            return this.$options.filters.rial(value.data.price_max);
          },
        },

        // {
        //   name: 'type',
        //   label: 'نوع',
        //   orderable: true,
        //   transform: (value) => {
        //     return this.notifyType(value.data.type);
        //   }
        // },

        // {
        //   name: 'status',
        //   label: 'وضعیت',
        //   orderable: true,
        //   transform: (value) => {
        //     return this.notifyStatus(value.data);
        //   }
        // },
        {
          name: "started_at",
          label: "شروع",
          orderable: true,
          transform: (value) => {
            return value.data.started_at !== null
              ? this.$options.filters.longDate(value.data.started_at)
              : "نامعلوم";
          },
        },

        {
          name: "expired_at",
          label: "پایان",
          orderable: true,
          transform: (value) => {
            return value.data.expired_at !== null
              ? this.$options.filters.longDate(value.data.expired_at)
              : "نامعلوم";
          },
        },
        // {
        //   name: 'cost',
        //   label: 'هزینه(ریال)',
        //   orderable: true,
        //   transform: (value) => {
        //     return value.data.cost !== null ? value.data.cost : "<span class='badge-success badge-pill'>رایگان </span>";
        //   }
        // },
        {
          name: "actions",
          label: "عملیات",
          component: Button,
          handler: this.actions,
          event: "action",
          meta: {
            permission_prefix: "notification_",
            buttons: [
              {
                name: "edit",
                label: "ویرایش",
                icon: "pencil-alt",
                class: "btn-edit",
              },
              {
                name: "delete",
                label: "حذف",
                icon: "trash",
                class: "btn-delete",
              },
            ],
          },
        },
      ],
      translate: {
        nextButton: "بعدی",
        previousButton: "قبلی",
        rowsPerPageText: "تعداد در صفحه",
        noDataText: "داده ای برای نمایش وجود ندارد",
        placeholderSearch: "جستجو",
      },
      tableProps: {
        search: "",
        length: 10,
        column: "id",
        dir: "desc",
      },
    };
  },
  methods: {
    reloadTable(tableProps) {
      this.getDiscounts(this.url, tableProps);
    },
    getDiscounts(url = this.url, query = this.tableProps) {
      this.loading = true;
      this.requestApiGet(url, query)
        .then((response) => {
          this.data = response;
          this.loading = false;
        })
        .catch((error) => {});
    },
    reload() {
      this.getDiscounts(this.url, this.tableProps);
    },

    actions(data, type) {
      this[type](data);
    },
    edit(data) {
      this.$router.push({
        name: "adminDiscounts.edit",
        params: { id: data.id },
      });
    },

    delete(data) {
      let id = data.id;
      this.$swal({
        title: "حذف",
        text: "آیا از حذف این دپارتمان اطمینان دارید؟",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        confirmButtonText: "حذف",
        cancelButtonText: "بازگشت",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.requestApiPost(this.url + "/delete/", { id: id }).then(
            (response) => {
              this.getDiscounts(this.url);
            }
          );
        }
      });
    },
    notifyStatus(data) {
      if (data.status === "pending") {
        return "در انتظار";
      } else if (data.status === "sent") {
        return "ارسال شده";
      } else if (data.status === "denied") {
        return "ارسال نشده";
      } else if (data.status === "payed") {
        return "پرداخت شده";
      } else if (data.status === "approved") {
        return "تایید شده";
      }
    },
  },
  created() {
    this.getDiscounts(this.url);
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t(this.$route.meta.title) },
    ]);
  },
};
</script>
